<template>
    <div>
        <b-card class="mt-md-1 mt-2">
            <div v-if="orderDetails">
                <h4 class="mb-0 text-info font-weight-bolder">اطلاعات فاکتور</h4>
                <b-row>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">شماره فاکتور</h5>
                                <h4 class="mb-0">{{ orderDetails.storeOrderNumber }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-info">
                                        <feather-icon size="20" icon="ShoppingBagIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">تاریخ</h5>
                                <h4 class="mb-0">
                                    <span>
                                        {{ new Date(orderDetails.createdAt).toLocaleDateString('fa-IR') }}
                                    </span>
                                    <span> - </span>
                                    <span>
                                        {{ new
                                            Date(orderDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                                2).join(":") }}
                                    </span>
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-info">
                                        <feather-icon size="20" icon="CalendarIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">شماره سفارش</h5>
                                <h4 class="mb-0">{{ orderDetails.dailyOrderNumber }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="ShoppingBagIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">ثبت کننده</h5>
                                <h4 class="mb-0">
                                    {{ orderDetails.registeredBy ? orderDetails.registeredBy.firstName + " " +
                                        orderDetails.registeredBy.lastName : 'مشتری' }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="UserIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">نوع سفارش</h5>
                                <h4 class="mb-0">{{ type_Status(orderDetails.type) }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="GridIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">تخفیف محصولات</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.productDiscountAmount ?
                                            orderDetails.productDiscountAmount.toLocaleString('fa-IR')
                                            : 0
                                        }}
                                    </h4>
                                    <h6 v-if="orderDetails.productDiscountAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="PercentIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">مبلغ کل</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.totalAmount ?
                                            orderDetails.totalAmount.toLocaleString('fa-IR')
                                            : 0
                                        }}
                                    </h4>
                                    <h6 v-if="orderDetails.totalAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="DollarSignIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">مالیات</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.taxAmount ?
                                            orderDetails.taxAmount.toLocaleString('fa-IR') : 0
                                        }}
                                    </h4>
                                    <h6 v-if="orderDetails.taxAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="CircleIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">تخفیف کمپین</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.campaign ?
                                            orderDetails.campaign.discountAmount.toLocaleString('fa-IR') : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.campaign" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="PercentIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">تخفیف دستی</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.discountAmount ?
                                            orderDetails.discountAmount.toLocaleString('fa-IR') : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.discountAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="PercentIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">هزینه ارسال</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.courierFee ?
                                            orderDetails.courierFee.toLocaleString('fa-IR') : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.courierFee" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="TruckIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">اعتبار استفاده شده</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.usedWalletAmount ?
                                            orderDetails.usedWalletAmount.toLocaleString('fa-IR') : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.usedWalletAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="CreditCardIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">مبلغ پرداخت شده</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.payableAmount ?
                                            orderDetails.payableAmount.toLocaleString('fa-IR')
                                            : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.payableAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="DollarSignIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">اعتبار صادر شده</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ orderDetails.cashbackAmount ?
                                            orderDetails.cashbackAmount.toLocaleString('fa-IR') : 0 }}
                                    </h4>
                                    <h6 v-if="orderDetails.cashbackAmount" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="CreditCardIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">جایگاه</h5>
                                <h4 class="mb-0">{{ orderDetails.tableName ? orderDetails.tableName : 'ثبت نشده' }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="HexagonIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.storeOrderNumber" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">نوع پرداخت</h5>
                                <h4 class="d-flex align-items-center mb-0">
                                    <div>{{ paymentMethod_Status(orderDetails.paymentMethod) }}</div>
                                    <div v-if="orderDetails.paymentMethod == 255">
                                        <b-button id="order-details-payments" variant="outline-light" class="p-0 ml-50"
                                            style="border: none !important;">
                                            <feather-icon icon="HelpCircleIcon" size="19" class="text-muted" />
                                        </b-button>
                                        <b-popover target="order-details-payments" variant="primary" triggers="hover"
                                            placement="top">
                                            <template #title>
                                                <span>پرداخت ترکیبی</span>
                                            </template>
                                            <div v-for="(item, index) in orderDetails.payments" :key="index"
                                                class="d-flex align-items-center" :class="{ 'mt-50': index != 0 }">
                                                <h5 class="text-secondary mb-0">
                                                    {{ paymentMethod_Status(item.method) }}:
                                                </h5>
                                                <h4 class="px-25 mb-0">
                                                    {{ item.amount.toLocaleString('fa-IR') }}
                                                </h4>
                                                <div>
                                                    ریال
                                                </div>
                                            </div>
                                        </b-popover>
                                    </div>
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="GridIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.customer" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">نام مشتری</h5>
                                <h4 class="mb-0">{{ orderDetails.customer.lastName ? orderDetails.customer.firstName +
                                    " " +
                                    orderDetails.customer.lastName : "مشتری مجموعه" }}</h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="UserIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.customer" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">شماره همراه مشتری</h5>
                                <h4 class="mb-0">
                                    {{ orderDetails.customer.phoneNumber }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="PhoneIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.customerDescription" md="12" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">توضیحات سفارش</h5>
                                <h5 class="mb-0">{{ orderDetails.customerDescription }}
                                </h5>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="FileTextIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="orderDetails.address" md="12" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">آدرس سفارش</h5>
                                <h5 class="mb-0">{{ orderDetails.address }}
                                </h5>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="HomeIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <h5 v-else class="text-center py-5">
                اطلاعاتی وجود ندارد
            </h5>
        </b-card>

        <b-card v-if="orderDetails">
            <b-table responsive :items="orderDetails.items" :fields="fields" class="mb-0" striped thead-class="d-none"
                borderless>
                <template #cell(productName)="data">
                    <div class="d-flex align-items-center">
                        <div style="width: 50px;height: 50px;">
                            <img v-if="data.item.productImage" :src="BASE_URL_File + data.item.productImage"
                                class="w-100 h-100 rounded object-fit-cover">
                            <img v-else src="@/assets/images/pages/default.jpg"
                                class="w-100 h-100 rounded object-fit-cover">
                        </div>
                        <div class="ml-1">
                            <h5 class="mb-0 font-weight-bolder">
                                {{ data.item.productName }}
                            </h5>
                            <div class="d-flex align-items-center mt-50">
                                <h5 class="mb-0 mr-25">{{ data.item.finalPrice.toLocaleString('fa-IR') }}</h5>
                                <h6 class="mb-0 pb-25">ریال</h6>
                            </div>
                        </div>
                    </div>
                </template>
                <template #cell(count)="data">
                    <div class="d-flex align-items-center justify-content-end">
                        <h4 class="font-weight-bolder mr-25 mb-0">{{ data.item.count }}</h4>
                        <span>عدد</span>
                    </div>
                </template>
            </b-table>
        </b-card>

    </div>
</template>

<script>
import { BCard, BRow, BCol, BAvatar, BMediaAside, BMedia, VBPopover, BPopover, BButton, BTable } from 'bootstrap-vue';

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BAvatar,
        BMediaAside,
        BMedia,
        BButton,
        BPopover,
        BTable
    },
    directives: {
        'b-popover': VBPopover,
    },
    data() {
        return {
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            fields: [
                {
                    key: 'productName',
                    label: 'نام',
                },
                {
                    key: 'count',
                    label: 'نعداد',
                },
            ],
        }
    },
    props: {
        orderDetails: {
            type: Object,
            default: () => { },
        },
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
        paymentMethod_Status() {
            return (status) => {
                if (status == 0) {
                    return 'نقدی'
                }
                if (status == 1) {
                    return 'کارت'
                }
                if (status == 2) {
                    return 'درگاه'
                }
                if (status == 3) {
                    return 'واریز به حساب'
                }
                if (status == 255) {
                    return 'ترکیبی'
                }
            }
        },
    },
};
</script>